module.exports = __webpack_public_path__ + "static/media/cdb23.dba0a0eb.png";